import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Environment } from '@dice/app/types/env.type';
import { ENV } from '@dice/config.tokens';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private env = inject<Environment>(ENV);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const setHeaders = this.getHeaders(req);
    const clonedRequest = req.clone({ setHeaders });

    return next.handle(clonedRequest);
  }

  private getHeaders(req: HttpRequest<any>): { [key: string]: string | string[] } {
    const headers: { [key: string]: string | string[] } = {};

    if (this.env.name !== 'development' && req.method === 'GET') {
      headers['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      headers['Cache-Control'] = 'no-cache';
      headers.Pragma = 'no-cache';
    }

    return headers;
  }
}
